<template>
  <v-dialog v-model="dialogIsOpen" max-width="400px">
    <v-card class="d-flex flex-column pt-16 px-16 rounded-lg" min-height="50vh">
      <v-card-text class="my-auto d-flex flex-column align-center">
        <p class="text-center font-weight-medium text-subtitle-1 px-4">{{ quantity }} {{ $t('label.itemsAddedToCart') }}</p>
      </v-card-text>

      <v-card-actions class="d-flex flex-column align-stretch">
        <app-button invert gradient :label="$t('button.goToCart')" :to="{ name: $constants.ROUTE_NAME.ORDER_CART }" class="py-5 mb-12" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    quantity: {
      type: Number
    },
    value: {
      type: Boolean
    }
  },
  // props: ['value'],
  // props: {
  //   quantity: {
  //     required: true
  //   }
  // },
  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(isOpen) {
        this.$emit('input', isOpen)
        this.$emit('close')
      }
    }
  }
}
</script>
